<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<circle style="fill:#F0F0F0;" cx="256" cy="256" r="256"/>
<path style="fill:#0052B4;" d="M256,512c141.384,0,256-114.616,256-256c0-31.314-5.632-61.311-15.923-89.043H15.923
	C5.633,194.689,0,224.686,0,256C0,397.384,114.616,512,256,512z"/>
<path style="fill:#D80027;" d="M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"/>
<path style="fill:#F0F0F0;" d="M66.198,144.696v127.706c0,72.644,94.901,94.903,94.901,94.903s94.9-22.259,94.9-94.903V144.696
	H66.198z"/>
<path style="fill:#D80027;" d="M88.459,144.696v127.706c0,8.528,1.894,16.582,5.646,24.133c37.234,0,92.886,0,133.987,0
	c3.752-7.55,5.646-15.605,5.646-24.133V144.696H88.459z"/>
<polygon style="fill:#F0F0F0;" points="205.62,233.739 172.23,233.739 172.23,211.478 194.491,211.478 194.491,189.217 
	172.23,189.217 172.23,166.957 149.969,166.957 149.969,189.217 127.709,189.217 127.709,211.478 149.969,211.478 149.969,233.739 
	116.577,233.739 116.577,256 149.969,256 149.969,278.261 172.23,278.261 172.23,256 205.62,256 "/>
<path style="fill:#0052B4;" d="M124.471,327.61c14.345,9.015,29.083,14.249,36.628,16.577c7.545-2.327,22.283-7.562,36.628-16.577
	c14.466-9.092,24.607-19.49,30.365-31.075c-6.351-4.493-14.1-7.143-22.471-7.143c-3.048,0-6.009,0.361-8.856,1.024
	c-6.033-13.708-19.728-23.285-35.665-23.285s-29.633,9.577-35.665,23.285c-2.847-0.663-5.809-1.024-8.856-1.024
	c-8.371,0-16.12,2.65-22.471,7.143C99.863,308.119,110.004,318.517,124.471,327.61z"/>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
